module.exports = __webpack_public_path__ + "fonts/CrimsonText-Regular-5.62f10d46.ttf";